export const SITE_NOT_UPDATED = "Saved, but the public site didn't update. Use Republish on the Site content page.";

/** Success message for a save, or a warning when the public site wasn't republished */
export function savedMessage(result, text) {
  if (result && result.sitePublished === false) {
    return { variant: 'warning', text: `${text} ${SITE_NOT_UPDATED}` };
  }
  return { variant: 'success', text };
}
